module.exports = __webpack_public_path__ + "img/up-arrow.f8ab0514.svg";